import { Request, BaseApiUrl } from "./api";

// 列表
export const getMatDeliverListPage = (params) => {
  return Request.get(`${BaseApiUrl}/api/MatDeliver/Get`, { params: params });
};

//新增
export const addMatDeliver = (params) => {
  return Request.post(`${BaseApiUrl}/api/MatDeliver/Post`, params);
};

//删除
export const removeMatDeliver = (params) => {
  return Request.post(`${BaseApiUrl}/api/MatDeliver/Delete`, params);
};

//获取详情
export const getMatDeliverDetail = (params) => {
  return Request.get(`${BaseApiUrl}/api/MatDeliver/Detail`, { params: params });
};
//基础信息
export const getMatDeliverBaseData = (params) => {
  return Request.get(`${BaseApiUrl}/api/MatDeliver/GetMatDeliverBaseData` );
};
